module.exports = __webpack_public_path__ + "fonts/MyriadPro-Semibold.b3ea9b5.woff2";